var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocusign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8869 27.8819V32.3931C27.8869 32.63 27.6955 32.8214 27.4586 32.8214H15.6019C15.365 32.8214 15.1736 32.63 15.1736 32.3931V20.5455C15.1736 20.3086 15.365 20.1172 15.6019 20.1172H20.104V27.4536C20.104 27.6905 20.2954 27.8819 20.5323 27.8819H27.8869Z",
    fill: "#4C00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8265 21.5208C32.8265 25.312 30.6119 27.8729 27.887 27.882V23.1065C27.887 22.9698 27.8323 22.8331 27.732 22.742L25.2532 20.2631C25.1529 20.1628 25.0253 20.1082 24.8886 20.1082H20.1132V15.6061C20.1132 15.3691 20.3045 15.1778 20.5415 15.1778H27.2217C30.3932 15.1686 32.8265 17.7204 32.8265 21.5208Z",
    fill: "#FF5252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.732 22.7321C27.8323 22.8324 27.887 22.9599 27.887 23.0967V27.8721H20.5415C20.3045 27.8721 20.1132 27.6807 20.1132 27.4438V20.1074H24.8886C25.0253 20.1074 25.162 20.1621 25.2532 20.2624L27.732 22.7321Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocusign);
export default __webpack_public_path__ + "static/media/Docusign.5d772f15a0f8d26132082e13a5013698.svg";
export { ForwardRef as ReactComponent };